/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Undo_LastInputs */



/**
* | output |
* | --- |
* | "Undo last draw" |
*
* @param {Raffle_Undo_LastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_undo_last = /** @type {((inputs?: Raffle_Undo_LastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Undo_LastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler le dernier tirage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshacer el último sorteo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desfazer o último sorteio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla l'ultima estrazione")
	return /** @type {LocalizedString} */ ("Undo last draw")
});